import React, { useState, useEffect } from 'react';
import { IconButton, Badge } from '@mui/material';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { notificationService } from '../services/NotificationService';
import NotificationCenter from './NotificationCenter';
import { useAuth } from '../contexts/AuthContext';

const NotificationButton: React.FC = () => {
  const { user } = useAuth();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      loadUnreadCount();
      // Vérifier les notifications non lues toutes les 30 secondes
      const interval = setInterval(loadUnreadCount, 30000);
      return () => clearInterval(interval);
    }
  }, [user]);

  const loadUnreadCount = async () => {
    if (!user) return;
    
    try {
      setLoading(true);
      const count = await notificationService.getUnreadCount(user.uid);
      setUnreadCount(count);
    } catch (error) {
      console.error('Erreur lors du chargement du nombre de notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    // Recharger le compteur après fermeture
    loadUnreadCount();
  };

  if (!user) {
    return null;
  }

  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleClick}
        disabled={loading}
        sx={{
          color: '#a5816d',
          '&:hover': {
            backgroundColor: 'rgba(165, 129, 109, 0.1)'
          }
        }}
      >
        <Badge 
          badgeContent={unreadCount} 
          color="error"
          max={99}
          sx={{
            '& .MuiBadge-badge': {
              backgroundColor: '#ff5722',
              color: 'white',
              fontSize: '0.7rem',
              fontWeight: 'bold'
            }
          }}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <NotificationCenter
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      />
    </>
  );
};

export default NotificationButton;
